<template>
  <v-data-table :headers="headers" :items="form.taxs" hide-default-footer disable-pagination>
    <template v-slot:top>
      <v-toolbar flat>
        <v-row>
          <v-col cols="12">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" dark rounded @click="add">
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </template>
              <span>Create</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-toolbar>
    </template>
    <template v-slot:item.no="{ index }">
      {{ index + 1 }}
    </template>
    <template v-slot:item.taxDate="{ item }">
      <v-menu
        v-model="item.menuTaxDate"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            outlined
            flat
            dense
            background-color="white"
            v-model="item.taxDate"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="item.taxDate" @input="item.menuTaxDate = false"></v-date-picker>
      </v-menu>
    </template>
    <template v-slot:item.taxNumber="{ item }">
      <v-text-field
        outlined
        flat
        dense
        background-color="white"
        v-model="item.taxNumber"
      ></v-text-field>
    </template>
    <template v-slot:item.pibDate="{ item }">
      <v-menu
        v-model="item.menuPibDate"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            outlined
            flat
            dense
            background-color="white"
            v-model="item.pibDate"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="item.pibDate" @input="item.menuPibDate = false"></v-date-picker>
      </v-menu>
    </template>
    <template v-slot:item.stan="{ item }">
      <v-text-field
        outlined
        flat
        dense
        background-color="white"
        v-model="item.stan"
        :rules="[v => !!v || 'Stan Number is required']"
      ></v-text-field>
    </template>
    <template v-slot:item.awb="{ item }">
      <v-text-field
        outlined
        flat
        dense
        background-color="white"
        v-model="item.awb"
        :rules="[v => !!v || 'AWB Number is required']"
      ></v-text-field>
    </template>
    <template v-slot:item.ntpn="{ item }">
      <v-text-field
        outlined
        flat
        dense
        background-color="white"
        v-model="item.ntpn"
        :rules="[v => !!v || 'NTPN Number is required']"
      ></v-text-field>
    </template>
    <template v-slot:item.invoice="{ item }">
      <v-autocomplete
        flat
        dense
        outlined
        background-color="white"
        item-text="invoiceNumber"
        append-icon="mdi-magnify"
        return-object
        :items="listInvoice"
        v-model="item.invoice"
        @change="onChangeInvoice($event, item)"
      >
      </v-autocomplete>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "form-tax-import",
  props: {
    form: Object,
    listInvoice: Array,
  },
  data: () => ({
    menuTaxDate: false,
    menuPibDate: false,
    headers: [
      {
        id: 1,
        text: "No",
        align: "center",
        sortable: false,
        value: "no",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 1,
        text: "Tax Date",
        align: "center",
        sortable: false,
        value: "taxDate",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 1,
        text: "Tax Number",
        align: "center",
        sortable: false,
        value: "taxNumber",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 1,
        text: "PIB Date",
        align: "center",
        sortable: false,
        value: "pibDate",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 1,
        text: "Stan",
        align: "center",
        sortable: false,
        value: "stan",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 1,
        text: "AWB",
        align: "center",
        sortable: false,
        value: "awb",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 1,
        text: "NTPN",
        align: "center",
        sortable: false,
        value: "ntpn",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 1,
        text: "Invoice",
        align: "center",
        sortable: false,
        value: "invoice",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
  }),

  methods: {
    onChangeInvoice(val, item) {
      item.invoiceId = val.id;
      item.invoiceType = val.type;
    },
    add() {
      this.$emit("add");
    },
  },
};
</script>

<style></style>
